import { render, staticRenderFns } from "./WEventPrice.vue?vue&type=template&id=5f9e7016&scoped=true&"
import script from "./WEventPrice.vue?vue&type=script&lang=js&"
export * from "./WEventPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e7016",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WMoney from '@/components/WMoney.vue'
autoInstallComponents(component, {WMoney})
